module.exports = {
  'i18n-demo': {
    message: {
      title: '运动品牌<br/>top 5'
    },
    placeholder: {
      enter: '请输入您喜欢的品牌'
    },
    brands: {
      nike: '耐克',
      adi: '阿迪达斯',
      nb: '新百伦',
      ln: '李宁'
    },
    love: '我喜欢{brand}',
    label_date: '现在是: '
  }
}



// WEBPACK FOOTER //
// ./src/lang/i18n-demo/zh-CN.js